// extracted by mini-css-extract-plugin
export default {"card":"TodoItem_card__89DMc","active":"TodoItem_active__qrHFd","buttons":"TodoItem_buttons__tBhc8","button":"TodoItem_button__6W+cA"};